import { useState, useEffect } from 'react';

import useProductQueryParams from 'src/hooks/use-product-query-params';

import { DispensaryStrainTypeOption } from 'shop/types/strain-type.types';
import {
  UseDispensaryStrainTypeProps,
  UseDispensaryStrainTypeReturn,
} from './dispensary-strain-type-filter-drawer.types';

export function useDispensaryStrainTypeFilter({ open }: UseDispensaryStrainTypeProps): UseDispensaryStrainTypeReturn {
  const [selectedOptions, setSelectedOptions] = useState<DispensaryStrainTypeOption[]>([]);
  const { queryParams, setQueryParams } = useProductQueryParams();

  useEffect(() => {
    if (open) {
      setSelectedOptions(queryParams.strainTypes);
    }
  }, [open, queryParams.strainTypes]);

  function handleSave(): void {
    setQueryParams({ strainTypes: selectedOptions });
  }

  function handleSelect(option: DispensaryStrainTypeOption): void {
    setSelectedOptions((previousOptions) =>
      previousOptions.includes(option)
        ? previousOptions.filter((selected) => selected !== option)
        : [...previousOptions, option]
    );
  }

  return { handleSave, handleSelect, selectedOptions };
}
